/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuth2DTO } from './OAuth2DTO';
import {
    OAuth2DTOFromJSON,
    OAuth2DTOFromJSONTyped,
    OAuth2DTOToJSON,
    OAuth2DTOToJSONTyped,
} from './OAuth2DTO';

/**
 * 
 * @export
 * @interface AuthenticationTypeDTO
 */
export interface AuthenticationTypeDTO {
    /**
     * 
     * @type {string}
     * @memberof AuthenticationTypeDTO
     */
    type?: string | null;
    /**
     * 
     * @type {OAuth2DTO}
     * @memberof AuthenticationTypeDTO
     */
    oAuth2?: OAuth2DTO;
}

/**
 * Check if a given object implements the AuthenticationTypeDTO interface.
 */
export function instanceOfAuthenticationTypeDTO(value: object): value is AuthenticationTypeDTO {
    return true;
}

export function AuthenticationTypeDTOFromJSON(json: any): AuthenticationTypeDTO {
    return AuthenticationTypeDTOFromJSONTyped(json, false);
}

export function AuthenticationTypeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthenticationTypeDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'oAuth2': json['oAuth2'] == null ? undefined : OAuth2DTOFromJSON(json['oAuth2']),
    };
}

export function AuthenticationTypeDTOToJSON(json: any): AuthenticationTypeDTO {
    return AuthenticationTypeDTOToJSONTyped(json, false);
}

export function AuthenticationTypeDTOToJSONTyped(value?: AuthenticationTypeDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'oAuth2': OAuth2DTOToJSON(value['oAuth2']),
    };
}

